import { Component, OnDestroy, ViewContainerRef, ViewChild, Compiler } from '@angular/core';
import { FormsModule, ReactiveFormsModule, Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { FormlyModule, FormlyFieldConfig, FormlyBootstrapModule, Field, FieldWrapper } from 'ng-formly';
import { LeadService } from '../lead.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { WorkflowConfigService } from '../workflowConfig.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-my-queue',
  templateUrl: './my-queue.component.html',
  styleUrls: ['./my-queue.component.css']
})
export class MyQueueComponent implements OnDestroy {
  @ViewChild('t') t;
  searchLeadForm: FormGroup;
  form: FormGroup = new FormGroup({});
  productId = '';
  subProductId = '';
  fosId = '';
  ApplicationStatus = '';
  applicationNo = '';
  ProductArray = [];
  SubProductArray = [];
  view_data = [];
  template: Array<any> = [];
  model: any = {};
  documentArray: Array<any> = [];
  documentArrayIsEmpty = true;
  documentIndex = 0;
  DocumentTypes = [];
  leadId: '';
  LeadRecords: Array<any> = [];
  nextAPllicationList: Array<any> = [];
  searchingData = false;
  gettingTemplate = false;
  fetchingCreditHistory = false;
  submittingdata = false;
  feedbackHistoryList = []
  isPopedUp = false;
  cancelReason = 0;
  cancelRemarks = '';
   isStatusSubmitting = false;

  noHit = false

  searchDataPaging = [];
  indexStart = 0;
  indexEnd = 10;
  pageSize = 5;
  pageNo = 1;
  totalPage = [1];
  userFields = [];
  user = {};
  activeTabsetId = '';
  applicationStatus = '';
  isSubProductload = false;

  tabs: Array<any> = [];
  values = [];
  branchList = [];

  LeadDetailArray = {};
  TemplateDetailArray = {};
  leadJSON: any = {
    validationContext: '',
    leadData: {}
  }
  showCreditInfoButton = false
  productParent = '';
  //upload document name start
  trnDocumentName = '';
  passportDocumentName = '';
  utilityBillDocumentName = '';
  jobLetterDocumentName = '';
  idProofFirstAuthorizedSignatoryName = '';
  idProofSecondAuthorizedSignatoryName = '';
  signedConsentName = '';
  //upload document name end
  //upload document name B2B start 
  companyTRNName = "";
  CompanyRegistrationDocName = "";
  CertificateofIncorporationName = "";
  IDofprimaryapplicantName = "";
  SignedConsentFormName = "";

  applicationStatusSubmitInfo = {
    ApplicationStatus: "",
    AssignTo: "",
    NextApplicationStatus: "",
    NextActionDate: "",
    Remarks: "",
    LeadId: this.leadId
  }

  //upload document name B2B end

  //popup Variables start here
  AppliactionAssignTo = '';
  ApplicationStatusAtCBS = '';
  ApplicationRemarks = '';
  //popup Variables end here

  crifScore = '';
  creditHistoryPath = '';
  contactHistoryPath = '';

  productName: '';
  fullName: '';
  applicationNumber: '';
  createdByName: '';
  subproductName: ''
  parentName: ''
  private fields: Array<FormlyFieldConfig> = [];
  public minDate: Date = void 0;
  profileIdentifications = [];
  uploadDocObject = {};
  tabButtonTitle = "Update";
  activeTabId = "ngb-tab-0";
  docActive = false;
  documentGetArray = [];
  isDesc: boolean = false;
  column: string = 'firstName';
  defaults: any = {}
  direction: number;
  isProductload;

  imageTemplate: any = {
    "className": "section-label",
    "template": "<div class='col-xs-6' style='text-align: center;''><h4>Customer Photograph From TAJ</h4><img style='height:235px; width:235px' src='assets/images/profile_pic.png'></div>"
  }
  showCrif = true
  currentUser: any = {}
  constructor(
    private fb: FormBuilder,
    private leadService: LeadService,
    public toastr: ToastsManager, vcr: ViewContainerRef,
    private config: WorkflowConfigService,
    private router: Router,
    private _compiler: Compiler
  ) {
    this.toastr.setRootViewContainerRef(vcr);
    this.searchLeadForm = this.fb.group({
      ProductId: '',
      SubProductId: '',
      FOSId: '',
      ApplicationStatus: '',
      ApplicationNo: '',
    });

    this.leadService.GetProductList()
      .subscribe(departmentListData => {
          this.isProductload = true;
        this.ProductArray = departmentListData;
      });

    this.leadService.fetchBaseBranches()
      .subscribe(departmentListData => {
        this.branchList = departmentListData;
      });
    this.currentUser = JSON.parse(window.localStorage['currentUser'])
    if (this.currentUser.roles) {
      if (this.currentUser.roles[0].designationId == "Credit Supervisor") {
        this.showCrif = false
      }

      // if (this.currentUser.roles[0].designationId == "Credit Officer") {
      //   this.showCrif = true
      // }
    }

    this.searchLeadForm = this.fb.group({
      ProductId: [this.productId],
      SubProductId: [this.subProductId],
      FOSId: [this.fosId],
      ApplicationStatus: [this.ApplicationStatus],
      ApplicationNo: [this.applicationNo],
    });
    this.defaults = this.config.defaults();
  }

  ngOnInit() {
    //   this.userService.currentUser.subscribe(
    //   (userData) => {
    //     debugger;
    //     this.currentUser = userData;
    //   }
    // )
  }

  ProductChange(str) {
 this.isSubProductload = true;
    for (var i = 0; i < this.ProductArray.length; i++) {
      if (this.searchLeadForm.value.ProductId == this.ProductArray[i]["name"]) {
        this.productParent = this.ProductArray[i]["parentName"];
      }
    }

    var temp1 = this.search(this.searchLeadForm.value.ProductId, this.ProductArray)
    this.productId = temp1.id
    this.productName = temp1.name
    this.parentName = temp1.parentName
    this.leadService.GetSubProductList(this.productId)
      .subscribe(departmentListData => {
        this.SubProductArray = departmentListData;
         this.isSubProductload = false;
      });
  }

  pagingAgent(data) {
    this.pageNo = data;
    this.indexStart = (this.pageNo - 1) * this.pageSize;
    this.indexEnd = (this.pageNo) * this.pageSize - 1;
  }

  changeItemsPerPage(data) {
    if (this.LeadRecords.length > 0) {
      this.totalPage = [1]
      let j = 1;
      for (var i = 0; i < this.LeadRecords.length; i++) {
        i = i + this.pageSize;
        j = j + 1;
        this.totalPage.push(j);
      }
    }
    else {
      this.totalPage = [];
    }
    this.pageSize = data;
    this.indexStart = 0;
    this.indexEnd = this.pageSize - 1;
  }


  searchLead() {
    this.searchingData = true;
    let data = {
      "applicationStatus": this.searchLeadForm.value.ApplicationStatus,
      "applicationNumber": this.searchLeadForm.value.ApplicationNo,
      "productName": this.searchLeadForm.value.ProductId,
      "subproductName": this.searchLeadForm.value.SubProductId,
      "branchId": this.searchLeadForm.value.FOSId
    }

    this.leadService
      .SearchQueue(data)
      .subscribe(result => {
        if (result.length > 0) {
          this.LeadRecords = [];
          let LeadRecords1 = [];
          LeadRecords1 = result;
          this.LeadRecords = LeadRecords1;
          this.searchDataPaging = [];
          this.searchingData = false;

          if (this.LeadRecords.length > 5) {
            let j = 1;
            for (var i = 0; i < this.LeadRecords.length; i++) {
              i = i + this.pageSize;
              j = j + 1;
              this.totalPage.push(j);
            }
          }
          for (var i = 0; i < this.LeadRecords.length; i++) {
            let arr: any = [];
            arr = this.LeadRecords[i];
            let rowNum = i;
            arr.applicationNumber = parseInt(arr.applicationNumber)
            this.searchDataPaging.push({ arr, "row": rowNum });
            this.isDesc = true;
            this.sort('applicationNumber');
          }
          this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
          this.indexEnd = 4;
        }
        else {
          this.toastr.info("No lead found.");
          this.searchingData = false;
          this.searchDataPaging = [];
        }
      },
      err => {
      });
  }

  handleChange(evt, name, createdByName, appNumber, applicationStatus, productName, subproductName) {
    for (var i = 0; i < this.searchDataPaging.length; i++) {

      if (this.searchDataPaging[i]["arr"]["leadId"] == evt) {

        if (this.searchDataPaging[i]["arr"]["productId"] != null) {
          // this.searchLeadForm.value.ProductId = this.searchDataPaging[i]["arr"]["productId"];
        }
        if (this.searchDataPaging[i]["arr"]["SubProductId"] != null) {
          // this.searchLeadForm.value.SubProductId = this.searchDataPaging[i]["arr"]["SubProductId"];
        }
      }
    }
    this.fullName = name;
    this.createdByName = createdByName;
    this.applicationNumber = appNumber;
    this.applicationStatus = applicationStatus
    this.applicationStatusSubmitInfo.ApplicationStatus = applicationStatus
    this.gettingTemplate = true;
    this.model = {};
    let inputParam = productName + ':' + subproductName;

    var parentObj = this.search(productName, this.ProductArray)

    this.productParent = parentObj.parentName

    this.leadId = evt
    this.leadService
      .fetchTemplateById(inputParam)
      .subscribe(result => {
        this.gettingTemplate = false;
        this.showCreditInfoButton = true;
        // if (this.activeTabId == 'ngb-tab-3' || this.activeTabId == 'ngb-tab-4') {
        //   this.showCreditInfoButton = false;
        // }
        this.template = result.templatedata;
        this.viewLeadDetails()
        for (var i = 0; i < this.template.length; i++) {
          if (this.template[i]["name"] == "Upload Media") {
            this.documentArray = this.template[i];
            this.documentIndex = i;
            this.documentArrayIsEmpty = false;
          }
        }

        if (!this.documentArrayIsEmpty) {
          this.template.splice(this.documentIndex, 1);
          let d = {
            "leadId": evt,//this.leadId
          };
          this.leadService.fetchLeadDocument(d).subscribe(result => {
            this.documentGetArray = [];
            this.documentGetArray = result;
            this.profileIdentifications = result;
            if (this.documentGetArray.length > 0) {
              for (var i = 0; i < this.documentGetArray.length; i++) {
                if (this.documentGetArray[i]["identificationDocTypeId"] == "tRNDocument") {
                  this.trnDocumentName = this.documentGetArray[i]["fileName"];
                }
                if (this.documentGetArray[i]["identificationDocTypeId"] == "passportDocument") {
                  this.passportDocumentName = this.documentGetArray[i]["fileName"];
                }
                if (this.documentGetArray[i]["identificationDocTypeId"] == "utilityBillDocument") {
                  this.utilityBillDocumentName = this.documentGetArray[i]["fileName"];
                }
                if (this.documentGetArray[i]["identificationDocTypeId"] == "jobLetter") {
                  this.jobLetterDocumentName = this.documentGetArray[i]["fileName"];
                }
                if (this.documentGetArray[i]["identificationDocTypeId"] == "iDProFirAuthSig") {
                  this.idProofFirstAuthorizedSignatoryName = this.documentGetArray[i]["fileName"];
                }
                if (this.documentGetArray[i]["identificationDocTypeId"] == "iDProSecAuthSig") {
                  this.idProofSecondAuthorizedSignatoryName = this.documentGetArray[i]["fileName"];
                }
                if (this.documentGetArray[i]["identificationDocTypeId"] == "signedConsent") {
                  this.signedConsentName = this.documentGetArray[i]["fileName"];
                }

                if (this.documentGetArray[i]["identificationDocTypeId"] == "companyTRN") {
                  this.companyTRNName = this.documentGetArray[i]["fileName"];
                }
                if (this.documentGetArray[i]["identificationDocTypeId"] == "companyRegistrationDoc") {
                  this.CompanyRegistrationDocName = this.documentGetArray[i]["fileName"];
                }
                if (this.documentGetArray[i]["identificationDocTypeId"] == "certificateOfIncorporation") {
                  this.CertificateofIncorporationName = this.documentGetArray[i]["fileName"];
                }
                if (this.documentGetArray[i]["identificationDocTypeId"] == "iDOfPrimaryApplicant") {
                  this.IDofprimaryapplicantName = this.documentGetArray[i]["fileName"];
                }
                if (this.documentGetArray[i]["identificationDocTypeId"] == "signedConsentForm") {
                  this.SignedConsentFormName = this.documentGetArray[i]["fileName"];
                }
              }
            }
            else {
              this.trnDocumentName = "";
              this.passportDocumentName = "";
              this.utilityBillDocumentName = "";
              this.jobLetterDocumentName = "";
              this.idProofFirstAuthorizedSignatoryName = "";
              this.idProofSecondAuthorizedSignatoryName = "";
              this.signedConsentName = "";
              this.companyTRNName = "";
              this.CompanyRegistrationDocName = "";
              this.CertificateofIncorporationName = "";
              this.IDofprimaryapplicantName = "";
              this.SignedConsentFormName = "";
            }
          });
        }
        if (this.productParent == "B2B") {
          this.trnSearchSetupB2B();
        }
        else if (this.productParent == 'Retail') {
          this.template[0].sections[0].fields[0] = this.imageTemplate;
          this.trnSearchSetup();
        }
        //this.template.pop();

        this.documentArrayIsEmpty = false;

        this.leadService
          .GetCreditHistoryScore(this.leadId)
          .subscribe(result => {
            if (result) {
              this.crifScore = result.creditScore;
              this.creditHistoryPath = result.creditHistoryScore[0].filename;
              this.contactHistoryPath = result.creditHistoryScore[1].filename;
            } else {
              // this.toastr.info("No Hit.");
              this.noHit = true
              this.creditHistoryPath = "javascript:void(0)"
              this.contactHistoryPath = "javascript:void(0)"
            }
          });

      },
      err => {
      });

    // Get Lead Data Service End
  }

  previewFile(key) {
    let documentExist = false;
    if (this.profileIdentifications.length > 0) {
      for (var i = 0; i < this.profileIdentifications.length; i++) {
        if (this.profileIdentifications[i]["identificationDocTypeId"] == key) {
          documentExist = true;
          var imagetype = this.profileIdentifications[i]['fileName'].substr(this.profileIdentifications[i]['fileName'].length - 3);
          this.leadService
            .filePreview(this.profileIdentifications[i]['fileName'])
            .subscribe(res => {
              if (imagetype == "pdf") {
                var mediaType = 'application/pdf';
              } else {
                var mediaType = 'image/jpeg';
              }
              var file = new Blob([res.blob()], { type: mediaType });
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(file);
              } else {
                let url = window.URL.createObjectURL(file);
                window.open(url);
              }
            });
        }
      }
    }
    if (documentExist == false) {
      if (this.documentGetArray.length > 0) {
        for (var i = 0; i < this.documentGetArray.length; i++) {
          if (this.documentGetArray[i]["identificationDocTypeId"] == key) {
            var imagetype = this.documentGetArray[i]['fileName'].substr(this.documentGetArray[i]['fileName'].length - 3);
            this.leadService
              .filePreview(this.documentGetArray[i]['fileName'])
              .subscribe(res => {
                if (imagetype == "pdf") {
                  var mediaType = 'application/pdf';
                } else {
                  var mediaType = 'image/jpeg';
                }
                var file = new Blob([res.blob()], { type: mediaType });
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                  window.navigator.msSaveOrOpenBlob(file);
                } else {
                  let url = window.URL.createObjectURL(file);
                  window.open(url);
                }
              });
          }
        }

      }
    }
  }

  viewLeadDetails() {
    this.leadService
      .leadDetailsById(this.leadId)
      .subscribe((data: any) => {
        this.model = data;
        this.model.customerconsent = true
        if (this.model.dateOfBirth) {
          this.model.dateOfBirth = data["dateOfBirth"] === null ? null : { year: +data["dateOfBirth"].toString().split('-')[0], month: +data["dateOfBirth"].toString().split('-')[1].replace('0', ''), day: +data["dateOfBirth"].toString().split('-')[2].replace('0', '') }
        }
        this.model["additionalCountry"] = data["additionalCountry"];
        this.model["additionalParish"] = data["additionalParish"];
        this.model["additionalPostOfficeCode"] = data["additionalPostOffice"];
        this.model["additionalStreetNumberAndName"] = data["additionalStreetNumAndName"];
        this.model["Country"] = data["mainCountry"];
        this.model["Parish"] = data["mainParish"];
        this.model["PostOffice"] = data["mainPostOffice"];
        this.model["StreetName"] = data["mainStreetName"];

        this.model["emailAddress"] = data["email"];
        this.model["mobileNumber"] = data["mobileno"];
        if (this.model.dateHired) {
          this.model.dateHired = data["dateHired"] === null ? null : { year: +data["dateHired"].toString().split('-')[0], month: +data["dateHired"].toString().split('-')[1].replace('0', ''), day: +data["dateHired"].toString().split('-')[2].replace('0', '') }
        }
        if (this.model.dateTerminated) {
          this.model.dateTerminated = data["dateTerminated"] === null ? null : { year: +data["dateTerminated"].toString().split('-')[0], month: +data["dateTerminated"].toString().split('-')[1].replace('0', ''), day: +data["dateTerminated"].toString().split('-')[2].replace('0', '') }
        }
        this.getnextApplicationStatusList(this.applicationStatus)
        if (this.productParent == 'Retail') {

     /*     let d1 = { "TRN": data["tRN"] }
            this.leadService.postTRN(d1).subscribe((d) => {
            if (d["photo"] == null) {
              this.imageTemplate = {
                "className": "section-label",
                "template": "<div class='col-xs-6' style='text-align: center;''><h4>Customer Photograph From TAJ</h4><img style='height:235px; width:235px' src='assets/images/TRN.jpg'></div>"
              }
              this.template[0].sections[0].fields[0] = this.imageTemplate;
            }
            else {
              this.imageTemplate = {
                "className": "section-label",
                "template": "<div class='col-xs-6' style='text-align: center;''><h4>Customer Photograph From TAJ</h4><img style='height:235px; width:235px' src='data:image/png;base64," + d["photo"] + "'></div>"
              }
              this.template[0].sections[0].fields[0] = this.imageTemplate;
            }

          }, error => { }); */

             if (data["profileimage"] == null) {
              this.imageTemplate = {
                "className": "section-label",
                "template": "<div class='col-xs-6' style='text-align: center;''><h4>Customer Photograph From TAJ</h4><img style='height:235px; width:235px' src='assets/images/TRN.jpg'></div>"
              }
              this.template[0].sections[0].fields[0] = this.imageTemplate;
            }
            else {
              this.imageTemplate = {
                "className": "section-label",
                "template": "<div class='col-xs-6' style='text-align: center;''><h4>Customer Photograph From TAJ</h4><img style='height:235px; width:235px' src='data:image/png;base64," + data["profileimage"] + "'></div>"
              }
              this.template[0].sections[0].fields[0] = this.imageTemplate;
            }

        }

        this.feedbackHistory();
        if (this.productParent == "B2B") {
          let d = {
            "TRN": data["tRN"],
            "CompanyType": data["typeOfCompany"],
            "TradeName": data["soleTraderName"],
            "product": this.productName,
            "subProduct": this.searchLeadForm.value.SubProductId
          }
          this.leadService
            .GetCreditHistoryB2BScore(d)
            .subscribe(result => {
              if (result) {
                this.crifScore = result.creditScore;
                this.creditHistoryPath = result.creditHistoryScore[0].filename;
                this.contactHistoryPath = result.creditHistoryScore[1].filename;
              } else {
                // this.toastr.info("No Hit.");
                this.noHit = true
                this.creditHistoryPath = "javascript:void(0)"
                this.contactHistoryPath = "javascript:void(0)"
              }

            });
        }

      });
  }
  feedbackHistory() {
    this.leadService.getFeedbackHistory(this.leadId).subscribe((result) => {
      this.feedbackHistoryList = result
    });
  }

  trnSearchSetupB2B() {
    this.docActive = false;

    this.leadService.fetchCountries().subscribe((result) => {
      let masterCountries = [];
      for (var i = 0; i < result.length; i++) {
        if (i == 0) {
          masterCountries.push({ "label": "Please Select", "value": "" });
        }
        masterCountries.push({ "label": result[i]["name"], "value": result[i]["id"] });
      }
      // this.template[0].sections[2].groups[0].fields[2].templateOptions.options = masterCountries;
      this.template[0].sections[1].groups[0].fields[4].templateOptions.options = masterCountries;
      this.template[0].sections[1].groups[1].fields[4].templateOptions.options = masterCountries;
      this.template[1].fields[10].templateOptions.options = masterCountries;
      this.template[2].fields[10].templateOptions.options = masterCountries;
    });
    this.leadService.fetchStates().subscribe((result) => {
      let masterStates = [];
      for (var i = 0; i < result.length; i++) {
        if (i == 0) {
          masterStates.push({ "label": "Please Select", "value": "" });
        }
        masterStates.push({ "label": result[i]["name"], "value": result[i]["id"] });
      }
      this.template[1].fields[6].templateOptions.options = masterStates;
      // this.template[0].sections[2].groups[0].fields[2].templateOptions.options = masterCountries;
      this.template[0].sections[1].groups[0].fields[2].templateOptions.options = masterStates;
      this.template[0].sections[1].groups[1].fields[2].templateOptions.options = masterStates;
      this.template[2].fields[6].templateOptions.options = masterStates;
    });
    this.leadService.fetchCities().subscribe((result) => {
      let masterCities = [];
      for (var i = 0; i < result.length; i++) {
        if (i == 0) {
          masterCities.push({ "label": "Please Select", "value": "" });
        }
        masterCities.push({ "label": result[i]["name"], "value": result[i]["id"] });
      }
      this.template[2].fields[7].templateOptions.options = masterCities;
      this.template[1].fields[7].templateOptions.options = masterCities;
      this.template[0].sections[1].groups[0].fields[1].templateOptions.options = masterCities;
      this.template[0].sections[1].groups[1].fields[1].templateOptions.options = masterCities;
    });

    this.leadService.fetchContactType().subscribe((result) => {
      let masterContacts = [];

      //this.template[0].sections[2].fields[0].templateOptions.options =[];
      for (var i = 0; i < result.length; i++) {
        if (i == 0) {
          masterContacts.push({ "label": "Please Select", "value": "" });
        }
        masterContacts.push({ "label": result[i]["Description"], "value": result[i]["Value"] });
      }
      this.template[0].sections[2].fields[0].templateOptions.options = masterContacts;
    });
    this.leadService.fetchOccupationType().subscribe((result) => {
      let masterOccupations = [];

      // this.template[1].fields[1].templateOptions.options = [];
      for (var i = 0; i < result["OccupationType"].length; i++) {
        if (i == 0) {
          masterOccupations.push({ "label": "Please Select", "value": "" });
        }
        masterOccupations.push({ "label": result["OccupationType"][i]["Description"], "value": result["OccupationType"][i]["Value"] });
      }
      this.template[1].fields[1].templateOptions.options = masterOccupations;
    });
    this.leadService.fetchCompanyType().subscribe((result) => {
      let masterOccupations = [];

      // this.template[0].sections[0].fields[1].templateOptions.options = [];
      for (var i = 0; i < result["CompanyType"].length; i++) {
        if (i == 0) {
          masterOccupations.push({ "label": "Please Select", "value": "" });
        }
        masterOccupations.push({ "label": result["CompanyType"][i]["Description"], "value": result["CompanyType"][i]["Value"] });
      }
      this.template[0].sections[0].fields[1].templateOptions.options = masterOccupations;
    });
    this.leadService.fetchBusinessType().subscribe((result) => {
      let masterOccupations = [];

      // this.template[0].sections[0].fields[4].templateOptions.options = [];
      for (var i = 0; i < result['BusinessType'].length; i++) {
        if (i == 0) {
          masterOccupations.push({ "label": "Please Select", "value": "" });
        }
        masterOccupations.push({ "label": result['BusinessType'][i]["Description"], "value": result['BusinessType'][i]["Value"] });
      }
      this.template[0].sections[0].fields[4].templateOptions.options = masterOccupations;
    });

    this.template[0].sections[1].groups[0]["fields"][0].templateOptions.disabled = true
    this.template[0].sections[1].groups[0]["fields"][1].templateOptions.disabled = true
    this.template[0].sections[1].groups[0]["fields"][2].templateOptions.disabled = true
    this.template[0].sections[1].groups[0]["fields"][3].templateOptions.disabled = true
    this.template[0].sections[1].groups[0]["fields"][4].templateOptions.disabled = true

    this.template[0].sections[1].groups[1]["fields"][0].templateOptions.disabled = true
    this.template[0].sections[1].groups[1]["fields"][1].templateOptions.disabled = true
    this.template[0].sections[1].groups[1]["fields"][2].templateOptions.disabled = true
    this.template[0].sections[1].groups[1]["fields"][3].templateOptions.disabled = true
    this.template[0].sections[1].groups[1]["fields"][4].templateOptions.disabled = true


    // this.template[0].sections[0].groups[0].["fields"][1].templateOptions.disabled = true
    if (this.currentUser.roles) {
      if (this.currentUser.roles[0].designationId == "CSR") {
        this.template[0].sections[0]["fields"][0].templateOptions.disabled = true
        this.template[0].sections[0]["fields"][1].templateOptions.disabled = true
        this.template[0].sections[0]["fields"][2].templateOptions.disabled = true
        this.template[0].sections[0]["fields"][3].templateOptions.disabled = true
        this.template[0].sections[0]["fields"][4].templateOptions.disabled = true

        this.template[0].sections[2]["fields"][0].templateOptions.disabled = true
        this.template[0].sections[2]["fields"][1].templateOptions.disabled = true
        this.template[0].sections[2]["fields"][2].templateOptions.disabled = true

        this.template[1]["fields"][0].templateOptions.disabled = true
        this.template[1]["fields"][1].templateOptions.disabled = true
        this.template[1]["fields"][2].templateOptions.disabled = true
        this.template[1]["fields"][3].templateOptions.disabled = true
        this.template[1]["fields"][4].templateOptions.disabled = true
        this.template[1]["fields"][5].templateOptions.disabled = true
        this.template[1]["fields"][6].templateOptions.disabled = true
        this.template[1]["fields"][7].templateOptions.disabled = true
        this.template[1]["fields"][8].templateOptions.disabled = true
        this.template[1]["fields"][9].templateOptions.disabled = true
        this.template[1]["fields"][10].templateOptions.disabled = true
        this.template[1]["fields"][11].templateOptions.disabled = true
        this.template[1]["fields"][12].templateOptions.disabled = true
        this.template[1]["fields"][13].templateOptions.disabled = true
        this.template[1]["fields"][14].templateOptions.disabled = true
        this.template[1]["fields"][15].templateOptions.disabled = true
        this.template[1]["fields"][16].templateOptions.disabled = true
        this.template[1]["fields"][17].templateOptions.disabled = true
        this.template[1]["fields"][18].templateOptions.disabled = true

        this.template[2]["fields"][0].templateOptions.disabled = true
        this.template[2]["fields"][1].templateOptions.disabled = true
        this.template[2]["fields"][2].templateOptions.disabled = true
        this.template[2]["fields"][3].templateOptions.disabled = true
        this.template[2]["fields"][4].templateOptions.disabled = true
        this.template[2]["fields"][5].templateOptions.disabled = true
        this.template[2]["fields"][6].templateOptions.disabled = true
        this.template[2]["fields"][7].templateOptions.disabled = true
        this.template[2]["fields"][8].templateOptions.disabled = true
        this.template[2]["fields"][9].templateOptions.disabled = true
        this.template[2]["fields"][10].templateOptions.disabled = true
        this.template[2]["fields"][11].templateOptions.disabled = true
        this.template[2]["fields"][12].templateOptions.disabled = true
        this.template[2]["fields"][13].templateOptions.disabled = true
        this.template[2]["fields"][14].templateOptions.disabled = true
        this.template[2]["fields"][15].templateOptions.disabled = true
        this.template[2]["fields"][16].templateOptions.disabled = true
        this.template[2]["fields"][17].templateOptions.disabled = true
      }
    }

  }
  trnSearchSetup() {
    // FieldDisabled
    this.template[0].sections[0].fields[1].templateOptions.disabled = true
    this.template[0].sections[0].fields[2].templateOptions.disabled = true
    this.template[0].sections[0].fields[3].templateOptions.disabled = true
    this.template[0].sections[0].fields[4].templateOptions.disabled = true
    this.template[0].sections[0].fields[5].templateOptions.disabled = true

    this.template[0].active = true
    this.template[1].active = true
    this.template[2].active = true
    this.docActive = false
    this.template[0].sections[2].fields[9].hideExpression = "model.isMailingAddressSameAsAbove==='Yes'"
    this.template[0].sections[2].fields[10].hideExpression = "model.isMailingAddressSameAsAbove==='Yes'"
    this.template[0].sections[2].fields[11].hideExpression = "model.isMailingAddressSameAsAbove==='Yes'"
    this.template[0].sections[2].fields[12].hideExpression = "model.isMailingAddressSameAsAbove==='Yes'"
    this.template[0].sections[2].fields[13].hideExpression = "model.isMailingAddressSameAsAbove==='Yes'"
    this.template[0].sections[2].fields[14].hideExpression = "model.isMailingAddressSameAsAbove==='Yes'"
    this.template[0].sections[2].fields[15].hideExpression = "model.isMailingAddressSameAsAbove==='Yes'"
    this.template[0].sections[2].fields[16].hideExpression = "model.isMailingAddressSameAsAbove==='Yes'"
    // this.template[0].sections[2].fields[17].hideExpression = "model.isMailingAddressSameAsAbove==='Yes'"

    this.template[0].sections[2]["fields"][7].templateOptions.disabled = true
    this.template[1]["fields"][10].templateOptions.disabled = true
    this.template[2]["fields"][10].templateOptions.disabled = true
    if (this.currentUser.roles) {
      if (this.currentUser.roles[0].designationId == "CSR") {
        this.template[0].sections[0]["fields"][1].templateOptions.disabled = true
        this.template[0].sections[0]["fields"][2].templateOptions.disabled = true
        this.template[0].sections[0]["fields"][3].templateOptions.disabled = true
        this.template[0].sections[0]["fields"][4].templateOptions.disabled = true
        this.template[0].sections[0]["fields"][5].templateOptions.disabled = true
        this.template[0].sections[0]["fields"][6].templateOptions.disabled = true
        this.template[0].sections[0]["fields"][7].templateOptions.disabled = true
        this.template[0].sections[0]["fields"][8].templateOptions.disabled = true
        this.template[0].sections[0]["fields"][9].templateOptions.disabled = true
        this.template[0].sections[0]["fields"][10].templateOptions.disabled = true
        this.template[0].sections[0]["fields"][11].templateOptions.disabled = true

        this.template[0].sections[1]["fields"][0].templateOptions.disabled = true
        this.template[0].sections[1]["fields"][1].templateOptions.disabled = true
        this.template[0].sections[1]["fields"][2].templateOptions.disabled = true
        this.template[0].sections[1]["fields"][3].templateOptions.disabled = true

        this.template[1]["fields"][0].templateOptions.disabled = true
        this.template[1]["fields"][1].templateOptions.disabled = true
        this.template[1]["fields"][2].templateOptions.disabled = true
        this.template[1]["fields"][3].templateOptions.disabled = true
        this.template[1]["fields"][4].templateOptions.disabled = true
        this.template[1]["fields"][5].templateOptions.disabled = true
        this.template[1]["fields"][6].templateOptions.disabled = true
        this.template[1]["fields"][7].templateOptions.disabled = true
        this.template[1]["fields"][8].templateOptions.disabled = true
        this.template[1]["fields"][9].templateOptions.disabled = true
        this.template[1]["fields"][10].templateOptions.disabled = true
        this.template[1]["fields"][11].templateOptions.disabled = true
        this.template[1]["fields"][12].templateOptions.disabled = true
        this.template[1]["fields"][13].templateOptions.disabled = true
        this.template[1]["fields"][14].templateOptions.disabled = true
        this.template[1]["fields"][15].templateOptions.disabled = true
        this.template[1]["fields"][16].templateOptions.disabled = true
        this.template[1]["fields"][17].templateOptions.disabled = true
        this.template[1]["fields"][18].templateOptions.disabled = true

        this.template[2]["fields"][0].templateOptions.disabled = true
        this.template[2]["fields"][1].templateOptions.disabled = true
        this.template[2]["fields"][2].templateOptions.disabled = true
        this.template[2]["fields"][3].templateOptions.disabled = true
        this.template[2]["fields"][4].templateOptions.disabled = true
        this.template[2]["fields"][5].templateOptions.disabled = true
        this.template[2]["fields"][6].templateOptions.disabled = true
        this.template[2]["fields"][7].templateOptions.disabled = true
        this.template[2]["fields"][8].templateOptions.disabled = true
        this.template[2]["fields"][9].templateOptions.disabled = true
        this.template[2]["fields"][10].templateOptions.disabled = true
        this.template[2]["fields"][11].templateOptions.disabled = true
        this.template[2]["fields"][12].templateOptions.disabled = true
        this.template[2]["fields"][13].templateOptions.disabled = true
        this.template[2]["fields"][14].templateOptions.disabled = true
        this.template[2]["fields"][15].templateOptions.disabled = true
        this.template[2]["fields"][16].templateOptions.disabled = true
        this.template[2]["fields"][17].templateOptions.disabled = true
      }
    }
  }
  search(nameKey, myArray) {
    for (var i = 0; i < myArray.length; i++) {
      if (myArray[i].name === nameKey) {
        return myArray[i];
      }
    }
  }

  ngOnDestroy() {
    // window.location.reload();
    this._compiler.clearCache();
  }

  cancleClick() {
    this.isPopedUp = true;
  }

  cancel() {
    this.isPopedUp = false;
  }

  cancelApiCall() {
    // console.log(this.leadId);

    if (this.leadId != undefined) {
      let data = {
        "CancellationReasonId": this.cancelReason,
        "Remarks": this.cancelRemarks,
        "LeadId": this.leadId,
      }
      this.leadService
        .CancelLeadApi(data)
        .subscribe((d: any) => {
          this.isPopedUp = false;
          this.toastr.success("Lead cancelled successfully.");
          setTimeout(() => {
            this.router.navigate(['']);
          }, 2000);
        });
    }
    else {
      this.isPopedUp = false;
      this.toastr.error("You need to save lead before cancel.");
    }

  }

  submit() {
    this.submittingdata = true;
    // delete this.model["dateOfBirth"];
    // delete this.model["customerconsent"];
    if (this.model.dateOfBirth) {
      // this.model["dateOfBirth"] = this.model["dateOfBirth"]["year"].toString() + '-' + this.model["dateOfBirth"]["month"].toString() + '-' + this.model["dateOfBirth"]["day"].toString();
    }

    this.model.productName = this.productName
    this.model.subproductName = this.subproductName


    // let id = +this.activeTabId.split('-')[2];


    // if (id >= 5) {
    //   id = id % 5;
    // }
    // this.activeTabId = "ngb-tab-" + id.toString();


    if (this.t.activeId == "Level 1") {
      this.model.email = this.model.emailAddress
      this.model.mobileno = this.model.mobileNumber
      delete this.model["emailAddress"]
      delete this.model["mobileNumber"]

      //var patternEmail = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
      var patternEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+(co\.in|com|org|net|int|edu|gov|mil)))$/;
      var patternMobile = /^(\+91-|\+91|0)?\d{10,13}$/;
      let requiredError = false;
      let emailError = false;
      let mobileError = false;
      let dateOfBirthError = false;
      let idExpirationDate = false;
      if (typeof (this.model.dateOfBirth) == 'object') {
        let year = this.model.dateOfBirth["year"].toString();
        let month = this.model.dateOfBirth["month"].toString().length == 1 ? '0' + this.model.dateOfBirth["month"].toString() : this.model.dateOfBirth["month"].toString();
        let day = this.model.dateOfBirth["day"].toString().length == 1 ? '0' + this.model.dateOfBirth["day"].toString() : this.model.dateOfBirth["day"].toString();
        let date = year + '-' + month + '-' + day;
        let birthDate = new Date(date + 'T10:20:30Z');

        var today = new Date();
        //var year = +this.model.dateofBirth.split('-')[0] - today.getFullYear();                
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        if (age < 18) {
          dateOfBirthError = true;
        }
        if (typeof (this.model.dateOfBirth) == 'object') {
          this.model.dateOfBirth = (this.model.dateOfBirth["year"] + '-' + this.model.dateOfBirth["month"] + '-' + + this.model.dateOfBirth["day"]).toString()
        }
      }
      else if (this.model.dateOfBirth != '' && this.model.dateOfBirth != undefined && this.model.dateOfBirth != null) {
        let year = this.model.dateOfBirth.split('-')[0].toString();
        let month = this.model.dateOfBirth.split('-')[1].toString().length == 1 ? '0' + this.model.dateOfBirth.split('-')[1].toString() : this.model.dateOfBirth.split('-')[1].toString();
        let day = this.model.dateOfBirth.split('-')[2].toString().length == 1 ? '0' + this.model.dateOfBirth.split('-')[2].toString() : this.model.dateOfBirth.split('-')[2].toString();
        let date = year + '-' + month + '-' + day;
        //let date = this.model.dateOfBirth;
        let birthDate = new Date(date + 'T10:20:30Z');

        var today = new Date();
        //var year = +this.model.dateofBirth.split('-')[0] - today.getFullYear();                
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        if (age < 18) {
          dateOfBirthError = true;
        }
        if (typeof (this.model.dateOfBirth) == 'object') {
          this.model.dateOfBirth = (this.model.dateOfBirth["year"] + '-' + this.model.dateOfBirth["month"] + '-' + + this.model.dateOfBirth["day"]).toString()
        }
      }
      if (typeof (this.model.iDExpirationDate) == 'object') {
        let year = this.model.iDExpirationDate["year"].toString();
        let month = this.model.iDExpirationDate["month"].toString().length == 1 ? '0' + this.model.iDExpirationDate["month"].toString() : this.model.iDExpirationDate["month"].toString();
        let day = this.model.iDExpirationDate["day"].toString().length == 1 ? '0' + this.model.iDExpirationDate["day"].toString() : this.model.iDExpirationDate["day"].toString();
        let date = year + '-' + month + '-' + day;
        let birthDate = new Date(date + 'T10:20:30Z');

        var now = new Date();
        now.setHours(0, 0, 0, 0);
        if (birthDate < now) {
          idExpirationDate = true;
          // selected date is in the past
        }
        if (typeof (this.model.iDExpirationDate) == 'object') {
          this.model.iDExpirationDate = (this.model.iDExpirationDate["year"] + '-' + this.model.iDExpirationDate["month"] + '-' + + this.model.iDExpirationDate["day"]).toString()
        }
      }
      else if (this.model.iDExpirationDate != '' && this.model.iDExpirationDate != undefined && this.model.iDExpirationDate != null) {
        let year = this.model.iDExpirationDate.split('-')[0].toString();
        let month = this.model.iDExpirationDate.split('-')[1].toString().length == 1 ? '0' + this.model.iDExpirationDate.split('-')[1].toString() : this.model.iDExpirationDate.split('-')[1].toString();
        let day = this.model.iDExpirationDate.split('-')[2].toString().length == 1 ? '0' + this.model.iDExpirationDate.split('-')[2].toString() : this.model.iDExpirationDate.split('-')[2].toString();

        let date = year + '-' + month + '-' + day;
        let birthDate = new Date(date + 'T10:20:30Z');

        var now = new Date();
        now.setHours(0, 0, 0, 0);
        if (birthDate < now) {
          idExpirationDate = true;
          // selected date is in the past
        }
        if (typeof (this.model.iDExpirationDate) == 'object') {
          this.model.iDExpirationDate = (this.model.iDExpirationDate["year"] + '-' + this.model.iDExpirationDate["month"] + '-' + + this.model.iDExpirationDate["day"]).toString()
        }
      }
      if (this.model.email != null && this.model.email != "") {
        if (!this.model.email.match(patternEmail)) {
          emailError = true;
        }
      }
      else {
        emailError = false;
      }

      if (this.model.mobileno != null && this.model.mobileno != "") {
        if (!this.model.mobileno.match(patternMobile)) {
          mobileError = true;
        }
      }
      else {
        mobileError = false;
      }

      for (var i = 0; i < this.template[0]['sections'].length; i++) {
        for (var j = 0; j < this.template[0]['sections'][i]["fields"].length; j++) {
          if (this.template[0]['sections'][i]["fields"][j]['templateOptions'] != undefined) {
            if (this.template[0]['sections'][i]["fields"][j]['templateOptions']['required'] == true) {
              //this.requiredFieldsKey.push(this.template[0]['sections'][i]["fields"][j]['key']);
              var keyName = this.template[0]['sections'][i]["fields"][j]['key'];
              if (this.model[keyName] == undefined || this.model[keyName] == "" || this.model[keyName] == "Please Select") {
                requiredError = true;
              }
            }
          }
        }
      }
      if (requiredError) {
        this.toastr.error("Please fill  all the required fields in L1.");
        this.submittingdata = false;
      }
      else if (dateOfBirthError) {
        this.toastr.error("Please select date of birth more than 18 years");
        this.submittingdata = false;
      }
      else if (idExpirationDate) {
        this.toastr.error("Id Expiry date should be greater than today.");
        this.submittingdata = false;
      }
      else if (emailError) {
        this.toastr.error("Invalid email address.");
        this.submittingdata = false;
      }
      else if (mobileError) {
        this.toastr.error("Invalid mobile number.");
        this.submittingdata = false;
      }
      else {
        this.model["leadOriginator"] = "Browser";
        var dataTab2 = {
          'id': this.leadId,
          "validationContext": "test",
          "leadData": this.model
        };
        this.model.leadId = this.leadId
        if (this.model.dateHired) {
          if (typeof (this.model.dateHired) == 'object') {
            this.model.dateHired = (this.model.dateHired["year"] + '-' + this.model.dateHired["month"] + '-' + + this.model.dateHired["day"]).toString()
          }
        }
        if (this.model.dateTerminated) {
          if (typeof (this.model.dateTerminated) == 'object') {
            this.model.dateTerminated = (this.model.dateTerminated["year"] + '-' + this.model.dateTerminated["month"] + '-' + + this.model.dateTerminated["day"]).toString()
          }
        }
        if (this.t.activeId == "Level 1") {
          dataTab2["leadData"]['level'] = "levelone";
        }
        else if (this.t.activeId == "Level 2") {
          dataTab2["leadData"]['level'] = "leveltwo";
        }
        else if (this.t.activeId == "Level 3") {
          dataTab2["leadData"]['level'] = "levelthree";
        }
        this.leadService
          .updateLead(dataTab2)
          .subscribe((d: any) => {
            this.submittingdata = false;
            if (this.t.activeId == "Level 1") {
              this.toastr.success("Level 1 Updated Successfully.");
            }
            else if (this.t.activeId == "Level 2") {
              this.toastr.success("Level 2 Updated Successfully.");
            }
            else if (this.t.activeId == "Level 3") {
              this.toastr.success("Level 3 Updated Successfully.");
            }
          }, error => {
            this.toastr.error("Something went wrong.");
          });
      }
    }

    else if (this.t.activeId == "Level 2" || this.t.activeId == "Level 3") {
      this.model["leadOriginator"] = "Browser";
      var dataTab2 = {
        'id': this.leadId,
        "validationContext": "test",
        "leadData": this.model
      };
      this.model.leadId = this.leadId;
      if (this.model.dateHired) {
        if (typeof (this.model.dateHired) == 'object') {
          this.model.dateHired = (this.model.dateHired["year"] + '-' + this.model.dateHired["month"] + '-' + + this.model.dateHired["day"]).toString()
        }
      }
      if (this.model.dateTerminated) {
        if (typeof (this.model.dateTerminated) == 'object') {
          this.model.dateTerminated = (this.model.dateTerminated["year"] + '-' + this.model.dateTerminated["month"] + '-' + + this.model.dateTerminated["day"]).toString()
        }
      }
      if (this.t.activeId == "Level 1") {
        dataTab2["leadData"]['level'] = "levelone";
      }
      else if (this.t.activeId == "Level 2") {
        dataTab2["leadData"]['level'] = "leveltwo";
      }
      else if (this.t.activeId == "Level 3") {
        dataTab2["leadData"]['level'] = "levelthree";
      }
      this.leadService
        .updateLead(dataTab2)
        .subscribe((d: any) => {
          this.submittingdata = false;
          if (this.t.activeId == "Level 1") {
            this.toastr.success("Level 1 Updated Successfully.");
          }
          else if (this.t.activeId == "Level 2") {
            this.toastr.success("Level 2 Updated Successfully.");
          }
          else if (this.t.activeId == "Level 3") {
            this.toastr.success("Level 3 Updated Successfully.");
          }
        }, error => {
          this.toastr.error("Something went wrong.");
        });
    }
    else if (this.t.activeId == "Upload Media") {
      var dataTab4 = {
        "leadId": this.leadId,
        "profileIdentifications": this.profileIdentifications,
        "documentStatus": "completed"
      }
      this.leadService
        .updateLeadDocuments(dataTab4)
        .subscribe((d: any) => {
          this.submittingdata = false;
          this.leadId = d.message;
          this.toastr.success("Upload Media Updated Successfully.");
        }, error => {
          this.toastr.error("Filename should not contain special characters");
        });
    }
  }

  submitFormly(obj) {
  }
  tabClick(activeId) {
    if (activeId == "Level 1") {
      this.showCreditInfoButton = true;
    } else {
      this.showCreditInfoButton = false;
    }
    // this.activeTabsetId = activeId;
    // let id = activeId.split('-')[2];
    // this.tabButtonTitle = "Update";
    // this.activeTabId = activeId;
    // if (id >= 8) {
    //   id = (id - 2) % 3;
    // }
    // else if (id >= 4) {
    //   id = id % 5;
    // }
    // if (id <= 0) {
    //   this.showCreditInfoButton = true
    // } else {
    //   this.showCreditInfoButton = false
    // }
  }
  sort(property) {
    this.isDesc = !this.isDesc; //change the direction    
    this.column = property;
    this.direction = this.isDesc ? 1 : -1;
  }
  addFileToDocument(docKey, event) {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];

      var fileSize = file.size / 1024;
      var fileSizeInMB = fileSize / 1000;

        var fileName = file.name;
      var fileNameString = /^[a-z0-9-.]+$/i.test(fileName);     
      if(fileNameString){
      if (fileSizeInMB < 2) {

        const fd: FormData = new FormData();
        fd.append('file', file);
        this.leadService
          .uploadFile(fd)
          .subscribe(data => {
            for (var i = 0; i < this.profileIdentifications.length; i++) {
              if (this.profileIdentifications[i]['identificationTypeId'] == docKey) {
                this.profileIdentifications.splice(i, 1);
              }
            }
            let obj = {
              "id": "",
              "path": data["path"],
              "fileName": data["fileName"],
              "identificationTypeId": docKey,
              "identificationDocTypeId": docKey,
              "identificationDocId": "",
              "deferredTillDate": "",
              "isDeferred": "",
              "IsWavedOff": "",
              "isDelete": "false",
              "tflexId": this.leadId
            };
            this.profileIdentifications.push(obj);
          }, error => {
            this.toastr.error("Filename should not contain special characters");
          });
        if (docKey == "tRNDocument") {
          this.trnDocumentName = file["name"];
        }
        if (docKey == "passportDocument") {
          this.passportDocumentName = file["name"];
        }
        if (docKey == "utilityBillDocument") {
          this.utilityBillDocumentName = file["name"];
        }
        if (docKey == "jobLetter") {
          this.jobLetterDocumentName = file["name"];
        }
        if (docKey == "iDProFirAuthSig") {
          this.idProofFirstAuthorizedSignatoryName = file["name"];
        }
        if (docKey == "iDProSecAuthSig") {
          this.idProofSecondAuthorizedSignatoryName = file["name"];
        }
        if (docKey == "signedConsent") {
          this.signedConsentName = file["name"];
        }
        if (docKey == "companyTRN") {
          this.companyTRNName = file["name"];
        }
        if (docKey == "companyRegistrationDoc") {
          this.CompanyRegistrationDocName = file["name"];
        }
        if (docKey == "certificateOfIncorporation") {
          this.CertificateofIncorporationName = file["name"];
        }
        if (docKey == "iDOfPrimaryApplicant") {
          this.IDofprimaryapplicantName = file["name"];
        }
        if (docKey == "signedConsentForm") {
          this.SignedConsentFormName = file["name"];
        }
      }
      else {
        this.toastr.error("File size should not be greater than 2 MB.");
      }
     }
    else{
       this.toastr.error("File name should not contain special characters and spaces.");
    }
    }
  }
  camelize = (str: string) => {
    return str
      .replace(/\s(.)/g, function ($1) { return $1.toUpperCase(); })
      .replace(/\s/g, '')
      .replace(/^(.)/, function ($1) { return $1.toLowerCase(); });
  }

  ContractHistory() {
    this.leadService.DownloadContractHistory(this.contactHistoryPath).subscribe((res) => {
      var mediaType = 'application/pdf';
      var file = new Blob([res.blob()], { type: mediaType });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(file);
      } else {
        let url = window.URL.createObjectURL(file);
        window.open(url);
      }
    }, error => {
    });
  }
  CreditHistory() {
    this.leadService.DownloadCreditHistory(this.creditHistoryPath).subscribe((res) => {
      var mediaType = 'application/pdf';
      var file = new Blob([res.blob()], { type: mediaType });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(file);
      } else {
        let url = window.URL.createObjectURL(file);
        window.open(url);
      }
    }, error => {
    });
  }

  getnextApplicationStatusList(data) {
    let statusInfo = {
      CurrentStatus: data
    }
    // this.leadService.getNextApplicationStatus(statusInfo).subscribe((data) => {
    //   this.nextAPllicationList = data
    // }, error => {
    // });
    if (this.currentUser.roles) {
      if (this.currentUser.roles[0].designationId == "CSR") {
        this.nextAPllicationList = []
      } else if (this.currentUser.roles[0].designationId == "Credit Officer") {
        this.nextAPllicationList = [
          {
            "nextWorkFlowStatus": "creditrejected",
            name: 'Credit Rejected'
          }, {
            "nextWorkFlowStatus": "creditreferred",
            name: 'Credit Referred'
          }, {
            "nextWorkFlowStatus": "creditaccepted",
            name: 'Credit Accepted'
          }]
      } else if (this.currentUser.roles[0].designationId == "Credit Supervisor") {
        this.nextAPllicationList = [{
          "nextWorkFlowStatus": "supervisorrejected",
          name: 'Supervisor Rejected'
        }, {
          "nextWorkFlowStatus": "supervisoraccepted",
          name: 'Supervisor Accepted'
        }]
      }
    }

  }

  ApplicationFormSubmit() {
    this.isStatusSubmitting = true;
    this.applicationStatusSubmitInfo.LeadId = this.leadId

    let statusInfo = {
      ApplicationStatus: this.applicationStatusSubmitInfo.NextApplicationStatus.toLowerCase(),
      AssignTo: this.applicationStatusSubmitInfo.AssignTo,
      NextApplicationStatus: this.applicationStatusSubmitInfo.NextApplicationStatus,
      NextActionDate: this.applicationStatusSubmitInfo.NextActionDate,
      Remarks: this.applicationStatusSubmitInfo.Remarks,
      LeadId: this.leadId
    }
    this.leadService.workflowLeadLevelUpdate(statusInfo).subscribe((data) => {
      this.toastr.success("Application Status Submitted Successfully.");
      this.isStatusSubmitting = false;
      this.applicationStatusSubmitInfo.Remarks = ''
      this.applicationStatusSubmitInfo.AssignTo = ''
      this.applicationStatusSubmitInfo.NextActionDate = ''
      this.applicationStatusSubmitInfo.NextApplicationStatus = ''
    }, error => {
      this.isStatusSubmitting = false;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/lead/my-queue/my-queue.component.ts